/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

export default baseLodash;



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/_baseLodash.js
// module id = 101
// module chunks = 0